import React, { Component } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import moment from "moment";
class SwtichBranchDialog extends Component {
  getEarliestDeliveryDate = (leadtime, publishedDate) => {
    let earliestDeliveryDate;
    if (publishedDate) {
      const publishedDateTime = moment(publishedDate).set({
        hour: moment().hour(),
        minute: moment().minute(),
        second: moment().second(),
        millisecond: moment().millisecond(),
      });

      earliestDeliveryDate = publishedDateTime.add(leadtime, "hours");
    } else {
      earliestDeliveryDate = moment().add(leadtime, "hours");
    }
    return earliestDeliveryDate.format("DD-MMM-YYYY HH:mm");
  };

  render() {
    const {
      language,
      customTexts,
      preorderingLeadTime,
      preorderingMode,
      publishedDate,
    } = this.props;
    return (
      <Dialog
        open={this.props.dialogOpen}
        onClose={() => this.props.onClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: language == "english" ? "left" : "right" }}
        >
          {preorderingMode
            ? language == "english"
              ? customTexts.preorder_popup_title
              : customTexts.preorder_popup_title_ar
            : language == "english"
            ? "This product is only available for preordering "
            : "هذا المنتج متوفر فقط للطلب المسبق"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ textAlign: language == "english" ? "left" : "right" }}
          >
            {language == "english"
              ? customTexts.preorder_popup_message
              : customTexts.preorder_popup_message_ar}
          </DialogContentText>
          <DialogContentText
            id="alert-dialog-description"
            style={{
              textAlign: language == "english" ? "left" : "right",
              direction: language === "arabic" && "rtl",
            }}
          >
            {preorderingMode ? (
              language == "english" ? (
                `*  Earliest time to deliver the product is on ${this.getEarliestDeliveryDate(
                  preorderingLeadTime
                )}`
              ) : (
                <span>
                  اقرب وقت لتوصيل المنتج هو{" "}
                  <span style={{ direction: "ltr", unicodeBidi: "embed" }}>
                    {this.getEarliestDeliveryDate(preorderingLeadTime)}
                  </span>
                  {" *"}
                </span>
              )
            ) : language == "english" ? (
              `*  Earliest time to deliver the product is on ${publishedDate}`
            ) : (
              <span>
                اقرب وقت لتوصيل المنتج هو{" "}
                <span style={{ direction: "ltr", unicodeBidi: "embed" }}>
                  {publishedDate}
                </span>
                {" *"}
              </span>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button onClick={() => this.props.yes()} color="primary">
            {language == "english" ? "Add to cart" : "أضف الى السلة"}
          </Button>
          <Button onClick={() => this.props.onClose()} color="primary">
            {language == "english" ? "No" : "لا"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customTexts: state.store.store.settings.custom_texts,
  };
};

export default connect(mapStateToProps)(SwtichBranchDialog);
